import { FormGroup, Stack, Typography } from '@mui/material';
import { AntStyleSwitch } from './AntStyleSwitch';

const TrueFalse = ({ active, handleChange }: { active: boolean; handleChange: any }) => {
  return (
    <FormGroup
      sx={{
        ml: '10px',
      }}
    >
      <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
        <Typography>False</Typography>
        <AntStyleSwitch checked={active} onClick={handleChange} />
        <Typography>True</Typography>
      </Stack>
    </FormGroup>
  );
};

export default TrueFalse;
